<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        DCI Revise
        <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content class="">
    <div class="eip-mt-20 eip-mb-10 eip-ml-20 eip-mr-20">
        <dynamic-form #docsetrevisionform [repeatCount]=4 name="docSet"></dynamic-form>
    </div>
    <div style="width: 23%;margin-left: 1%;" [formGroup]="docsetForm">
        <mat-form-field style="width: 30%;">
            <mat-label>Reason</mat-label>
            <input type="text" placeholder="" matInput required formControlName="reason">
            <mat-error *ngIf="docsetForm.get('reason').hasError('required')">
                Please Enter the Reason .
            </mat-error>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <span *ngIf="noOfDocs==0" class="no-wrap" eipTooltip="Number of documents for selected Structure Package has already reached its limit." eipTooltipPosition="left">
            <button class="btn btn-primary" id="btnSave" (click)="saveDocsetRevise()" [disabled]="true"><i class="fa fa-save" title="Save" aria-hidden="true"></i>&nbsp;&nbsp;Save</button>
        </span>
        <span *ngIf="noOfDocs>0">
            <button class="btn btn-primary" id="btnSave" (click)="saveDocsetRevise()"><i class="fa fa-save" title="Save" aria-hidden="true"></i>&nbsp;&nbsp;Save</button>
        </span>
        <button class="btn btn-secondary" id="btnSave" (click)="closeDialog()"><i class="fa fa-ban" title="Cancel" aria-hidden="true"></i>&nbsp;&nbsp;Cancel</button>
    </div>
</div>